import { ContextAction } from "types";

import { AppState, ContextActionType } from "./app.context";
import { ModalTypeValue } from "enums/modalType";

export const reducer = (
  state: AppState,
  action: ContextAction<ContextActionType, AppState>,
): AppState => {
  switch (action.type) {
    case "OPENMODAL":
      if (
        state.openModal !== ModalTypeValue.CLOSE &&
        action.payload.openModal !== ModalTypeValue.CLOSE
      ) {
        return state;
      }
      return {
        ...state,
        openModal: action.payload.openModal,
        code: action.payload.code,
        subgame: action.payload.subgame,
      };
    case "CHANGELANGUAGE":
      return {
        ...state,
        language: action.payload.language,
      };
    default:
      return state;
  }
};
